<div class="card">
  <div class="card-header flex-between">
    <h5 class="p-0 m-0">Tell Me</h5>
    <div>
      <button class="btn btn-primary-soft" (click)="load()" [disabled]="loading || savingTellMe">
        Refresh
      </button>
      <span class="button_Schedule_12">BETA</span>
    </div>
  </div>

  <div class="card-body center" *ngIf="loading">
    <img src="../assets/img/loading_2.svg" alt="loading scans" class="width-20px" />
  </div>

  <div class="card-body" *ngIf="!loading">
    <div class="alert alert-danger" *ngIf="errorMessage">
      {{ errorMessage }}
    </div>

    <div class="flex-start align-top" *ngIf="!errorMessage && scheduleData.length > 0">
      <div class="tab-content-wrapper flex-1">
        <nav>
          <div class="nav nav-tabs" role="tablist">
            <button
              class="nav-link capitalize"
              [ngClass]="{ active: schedule.key == selectedScheduleKey }"
              id="{{ schedule.key }}-tab"
              *ngFor="let schedule of scheduleData"
              type="button"
              role="tab"
              [attr.aria-controls]="schedule.key"
              [attr.aria-selected]="schedule.key == selectedScheduleKey"
              (click)="selectSchedule(schedule.key)"
            >
              {{ schedule.name }}
            </button>
          </div>
        </nav>

        <div class="tab-content flex-1 margin-top-20" id="azure-tell-me-schedule-tabs">
          <div
            *ngFor="let schedule of scheduleData"
            class="tab-pane fade show"
            [ngClass]="{ active: schedule.key == selectedScheduleKey }"
            id="{{ schedule.key }}"
            role="tabpanel"
            [attr.aria-labelledby]="schedule.key + '-tab'"
          >
            <nav>
              <div class="nav nav-tabs" role="tablist">
                <button
                  class="nav-link capitalize"
                  [ngClass]="{ active: isGroupActive(schedule.key, group.key) }"
                  id="{{ schedule.key + '-' + group.key }}-tab"
                      *ngFor="let group of schedule.groups"
                  type="button"
                  role="tab"
                  [attr.aria-controls]="schedule.key + '-' + group.key"
                  [attr.aria-selected]="isGroupActive(schedule.key, group.key)"
                  (click)="selectGroup(schedule.key, group.key)"
                >
                  {{ group.name }}
                </button>
              </div>
            </nav>

            <div class="tab-content flex-1 margin-top-20">
              <div
                *ngFor="let group of schedule.groups"
                class="tab-pane fade show"
                [ngClass]="{ active: isGroupActive(schedule.key, group.key) }"
                id="{{ schedule.key + '-' + group.key }}"
                role="tabpanel"
                [attr.aria-labelledby]="schedule.key + '-' + group.key + '-tab'"
              >
                <div class="card border-none">
                  <div class="card-header">{{ group.name }}</div>

                  <div class="card-body">
                    <div class="card-dply">
                      <div class="report-types-flex mb-10 card-postn">
                        <table class="table table-docs">
                          <thead>
                            <tr>
                              <th class="max-width-90">Sl. No.</th>
                              <th>Rule</th>
                              <th class="max-width-180">Enable/Disable</th>
                            </tr>
                          </thead>
                          <tbody *ngIf="group.rules.length > 0">
                            <tr *ngFor="let rule of group.rules; let i = index">
                              <td class="max-width-90">{{ rule.s_no || i + 1 }}</td>
                              <td>{{ rule.rule_name }}</td>
                              <td class="max-width-180">
                                <label class="switch" [ngClass]="{ dim_button: rule.saving || savingTellMe || !writeAccess }">
                                  <input
                                    autocomplete="off"
                                    type="checkbox"
                                    [(ngModel)]="rule.enabled"
                                    [disabled]="rule.saving || savingTellMe || !writeAccess"
                                    (change)="onRuleStatusChange(rule)"
                                  />
                                  <span class="slider round"></span>
                                </label>
                              </td>
                            </tr>
                          </tbody>
                          <tbody *ngIf="group.rules.length == 0">
                            <tr>
                              <td colspan="3" class="center">No Rules Found</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="width-350px">
        <div class="label pad-styl">Email IDs</div>

        <div class="additional_contacts">
          <div
            class="additional_contact width-auto"
            *ngFor="let contact of additionalContacts; let i = index; trackBy: trackByContactIndex"
          >
            <input
              autocomplete="off"
              type="text"
              name="contact_value"
              class="form-control"
              [(ngModel)]="additionalContacts[i]"
              [readonly]="i < existingEmailIds.length"
            />
            <div>
              <i
                class="fa fa-plus-circle pointer"
                aria-hidden="true"
                title="add"
                *ngIf="additionalContacts.length == i + 1"
                (click)="addAdditionalContact()"
              ></i>
            </div>
          </div>
        </div>

        <div class="error-text" *ngIf="totalAdditionalContacts() == 0">
          At least one email id is required
        </div>

        <div class="padding-5px">
          <button
            *ngIf="!savingEmails"
            type="button"
            class="btn btn-light btn-styl"
            [attr.disabled]="!writeAccess || !hasNewEmailIds() ? true : null"
            (click)="saveEmails()"
          >
            Update
          </button>
          <img
            src="../assets/img/loading_2.svg"
            *ngIf="savingEmails"
            alt="saving email ids"
            class="width-20px"
          />
        </div>
      </div>
    </div>

    <div class="tell-me-actions-bottom" *ngIf="!errorMessage && scheduleData.length > 0">
      <div class="light-text" *ngIf="pendingChangesCount == 0">No pending status updates</div>
      <div class="text-bold" *ngIf="pendingChangesCount > 0">
        {{ pendingChangesCount }} pending change{{ pendingChangesCount > 1 ? "s" : "" }}
      </div>

      <button
        *ngIf="!savingTellMe"
        type="button"
        class="btn btn-light btn-styl"
        [attr.disabled]="!writeAccess || pendingChangesCount == 0 ? true : null"
        (click)="submitChanges()"
      >
        Submit
      </button>
      <img src="../assets/img/loading_2.svg" *ngIf="savingTellMe" alt="saving tell me" class="width-20px" />

      <div class="readonly-text full-row" *ngIf="!writeAccess">
        You have read-only access.
      </div>
    </div>

    <div class="center" *ngIf="!errorMessage && scheduleData.length == 0">
      No Tell Me rules found.
    </div>
  </div>
</div>
